import { type Meta } from '../types/docs';
import { AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM, AUTOMATIONS_ANALYTICS_PROMPT_MODES } from './automationsAnalytics';

const META: Meta = {
  description: 'The user starts saving an automation prompt as a skill',
  name: 'automation_save_as_skill_started',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation being saved as a skill',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the automation uses a linked skill or a custom prompt',
      name: 'prompt_mode',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_PROMPT_MODES],
    },
  ],
};

export default META;
